export const PETS_BUTTONS = [
    {id: 1, emoji: '🐶', value: 'Dog', selected: false},
    {id: 2, emoji: '🐱', value: 'Cat', selected: false},
    {id: 0, emoji: '🚫', value: 'No Pets', selected: true},
];
